import { Heading } from "components/designV2/heading/heading";
import { Text } from "components/designV2/text/text";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { ColorV2 } from "config/colors";
import { ReactComponent as PictureIconSvg } from "images/icons/svg/v2/picture.svg";
import styled from "styled-components";
import { FormStyled } from "../registrationContainer/registrationContainer.styled";

export const StyledForm = styled(FormStyled)`
  max-width: 420px;
  gap: 16px;
  padding: 0 10px;
`;

export const StepLabel = styled(Text).attrs({
  typography: "s1",
  color: ColorV2.Blue2,
})`
  margin: 0 0 12px 0;
`;

export const StyledTitle = styled(Heading).attrs({
  level: "h3",
})`
  margin: 6px 0 8px 0;
`;

export const FieldLabel = styled(Text).attrs({
  typography: "b2",
  color: ColorV2.Blue4,
})`
  margin: 0;
`;

export const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  margin: 8px 0 18px 0;
  width: 100%;
`;

export const UploadButton = styled(PrimaryButton)`
  align-self: center;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const ProfileImageCircle = styled.div`
  width: 136px;
  height: 136px;
  min-width: 136px;
  min-height: 136px;
  border-radius: 999px;
  background: ${ColorV2.Blue7};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
`;

export const ProfileIconCircle = styled.div`
  width: 136px;
  height: 136px;
  min-width: 136px;
  min-height: 136px;
  border-radius: 999px;
  background: ${ColorV2.Blue6};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ProfilePlaceholderIcon = styled(PictureIconSvg)`
  width: 48px;
  height: 48px;
  color: ${ColorV2.Blue4};
`;

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;

  button {
    margin-top: 0;
  }
`;

export const TextAreaWrapper = styled.div`
  width: 100%;

  textarea {
    margin: 8px 0 0 0;
    min-height: 108px;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
  color: ${ColorV2.Blue1};
`;

export const ErrorText = styled(Text).attrs({
  typography: "s1",
  color: ColorV2.NegativeRed,
})`
  margin: 0;
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 22px;
  width: 100%;
`;

export const FinishButton = styled(PrimaryButton)``;

export const BackButton = styled(SecondaryButton)``;
